import PolicyEditor from "pstat-anywhere/components/document_control/PolicyEditor";
import { EDIT_TYPE } from "pstat-anywhere/components/document_control/PolicyEditor/utils";
import {
  TriggerEventOnMount,
  triggerPolicyEditEvent
} from "pstat-anywhere/utils/googleTagManager";
import LoadingSpinner from "pstat-design-system/LoadingSpinner";

// @flow
type Props = {
  documentEdit: Object
};

const EditPolicyPage = (props: Props) => {
  if (props.documentEdit && props.documentEdit.document) {
    return (
      <TriggerEventOnMount
        triggerEvent={() => {
          const document = props.documentEdit.document;
          const editForm = props.documentEdit.editForm;
          triggerPolicyEditEvent(
            document.name,
            editForm.category.name,
            document.pk
          );
        }}
      >
        <PolicyEditor
          error={false}
          document={props.documentEdit.document}
          documentSave={props.documentEdit.documentSave}
          editForm={props.documentEdit.editForm}
          tagForm={props.documentEdit.tagForm}
          saveForm={props.documentEdit.saveForm}
          scheduledEffectiveDateForm={
            props.documentEdit.scheduledEffectiveDateForm
          }
          policyActions={props.documentEdit.policyActions}
          route={props.route}
          alreadyChanged={props.documentEdit.alreadyChanged}
          rtlSupport={props.documentEdit.rtlSupport}
          newCkeditor={props.documentEdit.newCkeditor}
          type={EDIT_TYPE}
          enabledAutoSaveTimeout={true}
        />
      </TriggerEventOnMount>
    );
  } else {
    return <LoadingSpinner size={100} />;
  }
};

export default EditPolicyPage;
